import { render, staticRenderFns } from "./keywordsAssistant.vue?vue&type=template&id=610de8b1&scoped=true"
import script from "./keywordsAssistant.vue?vue&type=script&lang=js"
export * from "./keywordsAssistant.vue?vue&type=script&lang=js"
import style0 from "./keywordsAssistant.vue?vue&type=style&index=0&id=610de8b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610de8b1",
  null
  
)

export default component.exports